import "./styles.scss";

import React from "react";
import { Link } from "gatsby";
import clsx from "clsx";

import Badge from "../Badge";

const PostCard = ({
  image,
  title,
  badge,
  description,
  url,
  author,
  date,
  categories,
  variant,
}) => {
  const AuthorType = author?.url ? Link : "div";

  return (
    <div className={clsx("post-card", variant && `post-card--${variant}`)}>
      <div className="row">
        <div className="col-xl-3 col-lg-4">
          <div className="post-card__main">
            {image && (
              <Link className="post-card__content-thumbnail d-lg-none" to={url}>
                {typeof image === "string" ? (
                  <img src={image} alt={title} />
                ) : (
                  <img src={image} alt={title} />
                )}
                <div className="post-card__arrow">
                  <img
                    src={require("assets/icons/arrow-right--new.svg").default}
                    alt=""
                  />
                </div>
              </Link>
            )}
            <div className="d-flex flex-column flex-lg-column-reverse">
              {badge && (
                <div className="post-card__badge">
                  <Badge label={badge} variant={variant} />
                </div>
              )}
              <h3>{title}</h3>
            </div>
            {description && (
              <div
                className="post-card__content-description d-lg-none"
                dangerouslySetInnerHTML={{
                  __html: description.replaceAll(" [&hellip;]", "…"),
                }}
              />
            )}
            <div className="post-card__main-details">
              {author && (
                <div>
                  <p>Autor:</p>
                  <div>
                    <AuthorType className="post-card__author" to={author?.url}>
                      <div
                        className="post-card__author-avatar"
                        style={{ backgroundImage: `url(${author.image})` }}
                      />
                      <p className="post-card__author-name">
                        <span>{author.name}</span>
                      </p>
                    </AuthorType>
                    {date && <div className="post-card__date">{date}</div>}
                  </div>
                </div>
              )}
              {date && (
                <div>
                  <p>Opublikowano:</p>
                  <div>
                    <p>{date}</p>
                  </div>
                </div>
              )}
              {categories?.length > 0 && (
                <div>
                  <p>Kategorie:</p>
                  <div>
                    <ul>
                      {categories.map((category, index) => (
                        <li key={index}>
                          <Badge
                            label={category.name}
                            url={category.url}
                            variant={variant}
                          />
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="col-xl-9 col-lg-8 d-none d-lg-block">
          <div className="post-card__content">
            <Link className="post-card__content-thumbnail" to={url}>
              {typeof image === "string" ? (
                <img src={image} alt={title} />
              ) : (
                <img src={image} alt={title} />
              )}
            </Link>
            <div className="post-card__content-description">
              {description && (
                <div
                  dangerouslySetInnerHTML={{
                    __html: description.replaceAll(" [&hellip;]", "…"),
                  }}
                />
              )}
              <Link className="post-card__arrow d-none d-lg-flex" to={url}>
                <img
                  src={require("assets/icons/arrow-right--new.svg").default}
                  alt=""
                />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PostCard;
